import React, { useState } from "react";
import Header from "./../Layout/Header";
import PageTitle from "./../Pages/PageTitle";
import PostTable from "../component/PostTable";
import PostComponent from "../component/PostComponent";
import PostModal from "../component/PostModal";

const BuySell = (props) => {
  const [selectedPost, setSelectedPost] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const toggleModal = () => setIsModalOpen((prev) => !prev);
  const handlePostClick = (post, mode) => {
    setSelectedPost(post);
    setModalMode(mode);
    setIsModalOpen(true);
  };

  return (
    <div>
      <Header />
      <PageTitle />
      <div className="buy_sell mb-80">
        <div className="container">
          <PostComponent
            triggerRefresh={() => setRefreshTrigger((prev) => prev + 1)}
          />
          <PostTable
            onPostClick={handlePostClick}
            tableMode={"sell"}
            refreshTrigger={refreshTrigger}
          />
        </div>
      </div>
      <PostModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        post={selectedPost}
        mode={modalMode}
        triggerRefresh={() => setRefreshTrigger((prev) => prev + 1)}
      />
    </div>
  );
};
export default BuySell;
